import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "daster",
  style: {"padding":"0 30px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "d-flex flex-wrap flex-stack mb-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, "Acreditación"),
    /*#__PURE__*/_createElementVNode("span", null, "Administra información de participación en los eventos")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "options" })
], -1)
const _hoisted_3 = { class: "d-flex justify-content-between align-items-end mb-10" }
const _hoisted_4 = { class: "card-title d-flex align-items-end" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "row justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_CardEvent = _resolveComponent("CardEvent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          class: "w-250px",
          placeholder: `${_ctx.t('search')}...`,
          "prefix-icon": _ctx.Search,
          clearable: ""
        }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.filter.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.type) = $event)),
          label: "label position",
          onChange: _ctx.getEventos
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "" }, {
              default: _withCtx(() => [
                _createTextVNode("Todos")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "NAC" }, {
              default: _withCtx(() => [
                _createTextVNode("Nacional")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "INT" }, {
              default: _withCtx(() => [
                _createTextVNode("Internacional")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    (_ctx.listEvents.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEvents, (evento, index) => {
            return (_openBlock(), _createBlock(_component_CardEvent, {
              key: index,
              to: `acreditation/${evento.idevent}/manager/home`,
              evento: evento
            }, null, 8, ["to", "evento"]))
          }), 128))
        ])), [
          [_directive_loading, _ctx.loader]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getEventos
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("tryAgain")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ])
  ]))
}